"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const input_dialog_1 = require("../input-dialog");
class TextDialog extends input_dialog_1.default {
    // CAUTION  never ever try to store any dynamic state in a
    // TextDialog object since it is treated as immutable
    // Currently, solely ActiveModalDialog is known to be capable of
    // representing individual dialog instances.
    constructor(_textDialogConfig = {}) {
        super(_textDialogConfig); // call InputDialog's constructor
        this._textDialogConfig = _textDialogConfig;
        if (this._textDialogConfig.isPassword) {
            this.input.attr("type", "password");
        }
        else {
            this.input.attr("type", "text");
        }
    }
    get bodySelector() {
        const selector = this._textDialogConfig.bodySelector || ".text-modal-body";
        return `${this.rootSelector} ${selector}`;
    }
    get inputSelector() {
        const selector = this._textDialogConfig.inputSelector || "input";
        return `${this.bodySelector} ${selector}`;
    }
    get input() {
        return this.jQuery(this.inputSelector);
    }
    setInputValue(value) {
        if (!this._textDialogConfig.isPassword) {
            this.input.val(value);
        }
    }
    clearInputValue() {
        this.input.val("");
    }
    getInputValue() {
        return this.input.val();
    }
    focusInput() {
        this.input.trigger("focus");
    }
    selectInput() {
        this.input.trigger("select");
    }
    toString() {
        return "Text Dialog";
    }
}
exports.default = TextDialog;
